import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MyCircularProgress } from "../../../components/MyCircularProgress";
import { useTheme } from "../../../hooks/WebCheckinUsers/theme";

type ResolvedGuestLink = {
  kind: "checkin" | "checkout";
  reservation_id: string;
  date?: string;
  bus_id: string;
};

export const GuestLinkResolver: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const {  colorsTheme } = useTheme();
  useEffect(() => {
    if (!code) {
      setError("Link inválido.");
      return;
    }

    const resolve = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API?.replace(/\/$/, "");
        const response = await fetch(`${baseUrl}/guest-links/${encodeURIComponent(code)}`);

        if (!response.ok) {
          setError("Link não encontrado ou expirado.");
          return;
        }

        const data: ResolvedGuestLink = await response.json();
        localStorage.setItem("@web-checkin:bus_id", data.bus_id);

        if (data.kind === "checkout") {
          const params = new URLSearchParams({ reservation_id: data.reservation_id });
          navigate(`/checkout?${params.toString()}`, { replace: true });
          return;
        }

        const params = new URLSearchParams({ reservation_id: data.reservation_id });
        if (data.date) params.set("date", data.date);
        navigate(`/checkin?${params.toString()}`, { replace: true });
      } catch {
        setError("Não foi possível abrir o link. Tente novamente.");
      }
    };

    resolve();
  }, [code, navigate]);

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          textAlign: "center",
        }}
      >
        {error}
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
      }}
    >
      <MyCircularProgress size={30} color={colorsTheme.secondary.light}/>
    </div>
  );
};
